/**
 * Swedish labels for admin-managed subscription values
 */

import type { SubscriptionPlan, SubscriptionStatus } from '@/types/admin'

export const SUBSCRIPTION_PLAN_LABELS: Record<SubscriptionPlan, string> = {
  beta: 'Beta',
  free: 'Gratis',
  paid: 'Betald',
}

export const SUBSCRIPTION_STATUS_LABELS: Record<SubscriptionStatus, string> = {
  active: 'Aktiv',
  trialing: 'Provperiod',
  past_due: 'Förfallen betalning',
  canceled: 'Avslutad',
}
